// Типизированные обёртки и типы под /api/v1/docs/* (живая документация).
//
// Источник правды на бэке — astramarket.api.v1.docs.router.

import { request } from "./client";

export type DocsEndpointItem = {
  method: string;
  path: string;
  operation_id: string;
  summary: string;
  tag: string;
};

export type DocsServiceItem = {
  module: string;
  class_name: string;
  method_count: number;
};

export type DocsModelItem = {
  class_name: string;
  table_name: string;
  column_count: number;
};

export type DocsSectionSummary = {
  id: string;       // "api:apps" | "service:app_service" | "model:App"
  title: string;
  kind: "api" | "service" | "model" | "meta";
  count: number;
};

export type DocsIndex = {
  generated_at: string;
  api_title: string;
  api_version: string;
  sections: DocsSectionSummary[];
  endpoints: DocsEndpointItem[];
  services: DocsServiceItem[];
  models: DocsModelItem[];
};

// Полный эндпойнт — то, что вернёт /api/v1/docs/section/api:<tag>
export type DocsParameter = {
  name: string;
  location: string;
  required: boolean;
  schema: Record<string, unknown>;
  description: string | null;
  example: unknown;
};

export type DocsResponse = {
  status_code: string;
  description: string;
  schema: Record<string, unknown> | null;
  example: unknown;
};

export type DocsEndpoint = {
  method: string;
  path: string;
  tag: string;
  operation_id: string;
  summary: string;
  description: string;
  parameters: DocsParameter[];
  request_body_schema: Record<string, unknown> | null;
  request_body_example: unknown;
  responses: DocsResponse[];
  deprecated: boolean;
  curl_example: string;
  python_snippet: string;
};

export type DocsServiceMethod = {
  name: string;
  signature: string;
  docstring: string | null;
  is_public: boolean;
};

export type DocsService = {
  module: string;
  class_name: string;
  docstring: string | null;
  methods: DocsServiceMethod[];
};

export type DocsModelColumn = {
  name: string;
  type: string;
  nullable: boolean;
  primary_key: boolean;
  foreign_key: string | null;
  indexed: boolean;
  default: string | null;
  description: string | null;
};

export type DocsModel = {
  module: string;
  class_name: string;
  table_name: string;
  docstring: string | null;
  columns: DocsModelColumn[];
};

export type DocsSection = {
  id: string;
  title: string;
  kind: "api" | "service" | "model" | "meta";
  endpoints: DocsEndpoint[];
  services: DocsService[];
  models: DocsModel[];
  markdown: string | null;
};

// ─── HTTP wrappers ─────────────────────────────────────────────────────────

export function getDocsIndex(): Promise<DocsIndex> {
  return request<DocsIndex>("/docs/index");
}

export function getDocsSection(id: string): Promise<DocsSection> {
  return request<DocsSection>(`/docs/section/${encodeURIComponent(id)}`);
}
